<script setup>
import { storeToRefs } from 'pinia';
import { useEventStore } from '../stores/event-store';

/**
 * Events
 */
const { event, loading } = storeToRefs(useEventStore());
</script>

<template>
  <ul
    class="nav nav-underline mb-3 flex-nowrap overflow-x-auto h-nav"
    v-if="!loading && event"
  >
    <li class="nav-item">
      <RouterLink
        :to="{
          name: 'event.detail',
          params: { eventUrl: event.url },
        }"
        class="nav-link"
      >
        About
      </RouterLink>
    </li>
    <li class="nav-item">
      <RouterLink
        :to="{
          name: 'event.sector.list',
          params: { eventUrl: event.url },
        }"
        class="nav-link"
      >
        Sectors
      </RouterLink>
    </li>
    <li class="nav-item">
      <RouterLink
        :to="{
          name: 'event.session.list',
          params: { eventUrl: event.url },
        }"
        class="nav-link"
      >
        Sessions
      </RouterLink>
    </li>
    <li class="nav-item">
      <RouterLink
        :to="{
          name: 'event.group.list',
          params: { eventUrl: event.url },
        }"
        class="nav-link"
      >
        Groups
      </RouterLink>
    </li>
    <li class="nav-item">
      <RouterLink
        :to="{
          name: 'event.rotation.list',
          params: { eventUrl: event.url },
        }"
        class="nav-link"
      >
        Rotations
      </RouterLink>
    </li>
    <li class="nav-item">
      <RouterLink
        :to="{
          name: 'event.angler.list',
          params: { eventUrl: event.url },
        }"
        class="nav-link"
      >
        Anglers
      </RouterLink>
    </li>
    <li class="nav-item">
      <RouterLink
        :to="{
          name: 'event.team.list',
          params: { eventUrl: event.url },
        }"
        class="nav-link"
      >
        Teams
      </RouterLink>
    </li>
    <li class="nav-item">
      <RouterLink
        :to="{
          name: 'event.registration.list',
          params: { eventUrl: event.url },
        }"
        class="nav-link"
      >
        Registration
      </RouterLink>
    </li>
    <li class="nav-item">
      <RouterLink
        :to="{
          name: 'event.draw.list',
          params: { eventUrl: event.url },
        }"
        class="nav-link"
      >
        Draw
      </RouterLink>
    </li>
    <li class="nav-item">
      <RouterLink
        :to="{
          name: 'event.result.list',
          params: { eventUrl: event.url },
        }"
        class="nav-link"
      >
        Results
      </RouterLink>
    </li>
  </ul>
</template>

<style scoped>
.nav-item a {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0.875rem;
  margin-right: 0.875rem;
}
.event-nav a:hover {
  border-bottom: 3px solid var(--bs-primary);
}
.nav-link {
  border-bottom: 3px solid transparent;
}
.router-link-exact-active {
  border-bottom: 3px solid var(--bs-primary);
}
.h-nav {
  scrollbar-width: none;
}
@media (min-width: 768px) {
  .h-nav {
    scrollbar-width: auto;
  }
}
</style>
